module.exports = __webpack_public_path__ + "assets/img/20_157.b46d5c40.jpg";